import { withFrameBusProps } from '@jusbrasil-web/shared-frame-bus'
import { withUserSession, WithUserSessionReturn } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { BOX_MODAL_FRAME_BUS_ID } from '../../frame-bus'
import { BoxPageBase, BoxPageBaseProps } from './base'

export type BoxUniqueFeatureModalIframeProps = Partial<BoxPageBaseProps>

export const BoxUniqueFeatureModalIframe = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  return <BoxPageBase {...props} id={BOX_MODAL_FRAME_BUS_ID} enableCache />
}

const getServerSideProps: GetServerSideProps<
  BoxUniqueFeatureModalIframeProps & ReturnType<typeof withFrameBusProps> & WithUserSessionReturn
> = async (ctx) => {
  return {
    props: {
      ...withFrameBusProps(),
      ...withUserSession(ctx),
    },
  }
}

export const BoxUniqueFeatureModalIframeExports = { getServerSideProps }
